/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author minhlnt2@ghtk.vn on 03/08/2022.
 * @module SMART SCALE CONSTANTS
 */

import dayjs from "dayjs";

// Action constants
export const MODULE_NAME = "SMARTSCALE/";

export const SCALE_STATUS = {
  USING: {
    label: "Đang sử dụng",
    value: "USING",
    color: "#069255"
  },
  REPAIR: {
    label: "Đang sửa chữa",
    value: "REPAIR",
    color: "#ff0000"
  },
  NOT_USING: {
    label: "Không sử dụng",
    value: "NOT_USING",
    color: "#B5B5C3"
  }
};

export const IMAGE_STATUS = {
  true: {
    label: "Có ảnh đơn hàng",
    value: true,
    color: "#069255"
  },
  false: {
    label: "Không có ảnh đơn hàng",
    value: false,
    color: "#ff0000"
  }
};

export const SCALE_CAMERA_STATUS = {
  0: {
    label: "Offline",
    value: 0,
    color: "#ff0000"
  },
  1: {
    label: "Online",
    value: 1,
    color: "#069255"
  }
};

export const SCALE_VIEW = {
  6: {
    label: "x 6",
    value: 6,
    span: 4,
    height: "42vh",
    font: "13px",
    station_font: "12px"
  },
  8: {
    label: "x 8",
    value: 8,
    span: 3,
    height: "35vh",
    font: "13px",
    station_font: "12px"
  },
  12: {
    label: "x 12",
    value: 12,
    span: 2,
    height: "30vh",
    font: "12px",
    station_font: "11px"
  }
};

export const _handleRenderColumns = (record, tableConfig) => {
  let getIndex = index =>
    (tableConfig.pagination.current - 1) * tableConfig.pagination.pageSize +
    index +
    1;

  let columns = [];

  switch (record.deviceType) {
    case "MOBILE":
      columns = [
        {
          title: "STT",
          dataIndex: "index",
          key: "stt",
          align: "center",
          width: 20,
          render: (_, __, index) => getIndex(index)
        },
        {
          title: "Username",
          dataIndex: "username",
          width: 80
        },
        {
          title: "Thiết bị",
          children: [
            {
              title: "Mã",
              dataIndex: "device_id",
              width: 80
            },
            {
              title: "Tên",
              dataIndex: "device_name",
              width: 80
            },
            {
              title: "Loại",
              dataIndex: "device_type",
              width: 80
            },
            {
              title: "Chip",
              dataIndex: "device_chip",
              width: 80
            },
            {
              title: "Density",
              dataIndex: "device_density",
              width: 80
            },
            {
              title: "Version",
              dataIndex: "device_version",
              width: 80
            },
            {
              title: "Công ty",
              dataIndex: "device_company",
              width: 80
            },
            {
              title: "Online gần nhất",
              dataIndex: "last_time_online",
              width: 80,
              render: latest_online =>
                latest_online ? dayjs(latest_online).fromNow() : "-"
            }
          ]
        },
        {
          title: "App",
          children: [
            {
              title: "Tên",
              dataIndex: "app_type",
              width: 80
            },
            {
              title: "Version",
              dataIndex: "app_version",
              width: 80
            }
          ]
        }
      ];
      break;
    case "CONVEYOR":
      columns = [
        {
          title: "STT",
          dataIndex: "index",
          key: "stt",
          align: "center",
          width: "10%",
          render: (_, __, index) => getIndex(index)
        },
        {
          title: "Mã thiết bị",
          dataIndex: "device_id"
        },
        {
          title: "ESP MAC",
          dataIndex: "esp_mac"
        },
        {
          title: "Kho",
          dataIndex: "station_name"
        },
        {
          title: "Vị trí",
          dataIndex: "conveyor_info",
          render: value => {
            return value?.station_position || "";
          }
        },
        {
          title: "Nhà cung cấp",
          dataIndex: "device_company"
        },
        {
          title: "Thời gian nghiệm thu",
          dataIndex: "acceptance_time",
          render: value => {
            return value ? dayjs(value).format("YYYY-MM-DD") : "";
          }
        },
        {
          title: "Đã hoạt động",
          dataIndex: "acceptance_time",
          render: value => {
            return value
              ? `${dayjs()
                  .diff(value, "years", true)
                  .toFixed(1) + " năm"}`
              : "";
          }
        }
      ];
      break;

    default:
      columns = [
        {
          title: "STT",
          dataIndex: "index",
          key: "stt",
          align: "center",
          width: 20,
          render: (_, __, index) => getIndex(index)
        },
        {
          title: "Username",
          dataIndex: "username",
          width: 80
        },
        {
          title: "Thiết bị",
          children: [
            {
              title: "Mã",
              dataIndex: "device_id",
              width: 80
            },
            {
              title: "Tên",
              dataIndex: "device_name",
              width: 80
            },
            {
              title: "Loại",
              dataIndex: "device_type",
              width: 80
            },
            {
              title: "Chip",
              dataIndex: "device_chip",
              width: 80
            },
            {
              title: "Density",
              dataIndex: "device_density",
              width: 80
            },
            {
              title: "Version",
              dataIndex: "device_version",
              width: 80
            },
            {
              title: "Công ty",
              dataIndex: "device_company",
              width: 80
            },
            {
              title: "Online gần nhất",
              dataIndex: "last_time_online",
              width: 80,
              render: latest_online =>
                latest_online ? dayjs(latest_online).fromNow() : "-"
            }
          ]
        },
        {
          title: "App",
          children: [
            {
              title: "Tên",
              dataIndex: "app_type",
              width: 80
            },
            {
              title: "Version",
              dataIndex: "app_version",
              width: 80
            }
          ]
        }
      ];
      break;
  }

  return columns;
};

export const CHUTE_STRUCTURE = [
  {
    label: "Tôn",
    value: "Tôn"
  },
  {
    label: "Tôn - con lăn",
    value: "Tôn - con lăn"
  },
  {
    label: "Lưới thép",
    value: "Lưới thép"
  }
];

export const DEVICE_COMPANY = [
  "HÀ ANH",
  "INTECH",
  "TÂN PHONG",
  "TÂN TRIỀU",
  "THÀNH CÔNG",
  "GINFON",
  "DAMON"
];

export const CHUTE_TYPE = [
  {
    label: "Ngã 3",
    value: "Ngã 3"
  },
  {
    label: "Máng chia",
    value: "Máng chia"
  },
];

export const CONVEYOR_LOCATION = [
  {
    label: "INBOUND",
    value: "INBOUND"
  },
  {
    label: "OUTBOUND",
    value: "OUTBOUND"
  },
  {
    label: "SORTING",
    value: "SORTING"
  },
  {
    label: "TRUNG CHUYỂN",
    value: "TRUNG CHUYỂN"
  },
  {
    label: "RETURN",
    value: "RETURN"
  },
];
